import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { AnimationEvent } from '@angular/animations';

import {
  ToastData,
  TOAST_CONFIG_TOKEN,
  ToastConfig,
  TOAST_COLORS,
  TOAST_ICONS,
} from './toast-config';
import { ToastRef } from './toast-ref';
import { toastAnimations, ToastAnimationState } from './toast-animation';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['toast.component.css'],
  animations: [toastAnimations.fadeToast],
})
export class ToastComponent implements OnInit, OnDestroy {
  animationState: ToastAnimationState = 'default';
  iconType: string;
  toastColor: string;
  private intervalId;

  constructor(
    readonly data: ToastData,
    readonly ref: ToastRef,
    @Inject(TOAST_CONFIG_TOKEN) readonly toastConfig: ToastConfig
  ) {
    this.iconType = this.getToastIcon(data.type);
    this.toastColor = this.getToastColor(data.type);
  }

  getToastColor(type) {
    switch (type) {
      case 'warning':
        return TOAST_COLORS.WARNING;
      case 'error':
        return TOAST_COLORS.ERROR;
      case 'info':
        return TOAST_COLORS.INFO;
      default:
        return TOAST_COLORS.SUCCESS;
    }
  }
  getToastIcon(type) {
    switch (type) {
      case 'warning':
        return TOAST_ICONS.WARNING;
      case 'error':
        return TOAST_ICONS.ERROR;
      case 'info':
        return TOAST_ICONS.INFO;
      default:
        return TOAST_ICONS.SUCCESS;
    }
  }

  ngOnInit() {
    this.intervalId = setTimeout(
      () => (this.animationState = 'closing'),
      this.toastConfig.duration
    );
  }

  ngOnDestroy() {
    clearTimeout(this.intervalId);
  }

  close() {
    this.ref.close();
  }

  onFadeFinished(event: AnimationEvent) {
    const { toState } = event;
    const isFadeOut = (toState as ToastAnimationState) === 'closing';
    const itFinished = this.animationState === 'closing';

    if (isFadeOut && itFinished) {
      this.close();
    }
  }
}
